import React from 'react'
import { Shell } from '~/components/molecules/Shell'
import * as S from './styled'
// Hidden pending live data — re-enable with the reserve metrics / attestations /
// redemption sections below (sc-41623).
// import { AttestationList } from '~/components/molecules/AttestationList'
// import { useReserveMetrics } from './useReserveMetrics'

/*
const usd = (n: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 2,
  }).format(n)

const compact = (n: number) =>
  new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 2,
  }).format(n)

const pct = (ratio: number) => `${(ratio * 100).toFixed(1)}%`

const asOfLabel = (iso: string) =>
  new Date(iso).toLocaleString('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
*/

// AVIT landing page. Design "3b": two-tone mesh hero gradient + blue→green→gold mark.
export const Screen = () => {
  // const { data, status } = useReserveMetrics()

  return (
    <Shell>
      <S.ScreenWrapper>
        <S.Hero>
          <S.Mark src="/images/avit/avit.png" alt="Avit" />
          <h1>Avit</h1>
          <p>
            A programmatically compliant, bank-issued token pegged 1:1 to the US
            dollar. A tokenized deposit within the Hazel Network, designed to be
            a GENIUS Act regulated payment stablecoin beyond it.
          </p>
        </S.Hero>

        <S.Section>
          <h2>What is Avit?</h2>
          <S.Split>
            <S.SplitMain>
              <p>
                Avit is Hazel Network&apos;s unified token. A single, integrated
                smart contract issues Avit as a tokenized deposit when held
                within the consortium of banks, and as a stablecoin designed to
                comply with the GENIUS Act, redeemable one-to-one for a US
                dollar when held by anyone else. The legal character changes
                automatically at the consortium boundary, and reserve
                requirements are enforced at the protocol level.
              </p>
              <S.ContractLink
                href={
                  'https://eth.blockscout.com/address/0xCcdc193AcF86160dDC79E20F7e471e53f2AF8Ecb?tab=index'
                }
                target={'_blank'}
                rel={'noopener noreferrer'}
              >
                View the Avit contract on mainnet
              </S.ContractLink>
            </S.SplitMain>
            <S.Aside>
              <h3>Want to learn more?</h3>
              <p>The Hazel Network white paper covers the full design.</p>
              <S.CtaLink
                href={'/Hazel-Network-White-Paper.pdf'}
                target={'_blank'}
                rel={'noopener noreferrer'}
              >
                Read the white paper
              </S.CtaLink>
            </S.Aside>
          </S.Split>
        </S.Section>

        {/* Sections below are hidden pending live data — re-enable with the
            monthly attestation PDFs, on-chain reserve metrics, and the
            redemption page (sc-41623).

        <S.Section>
          <h2>Reserve metrics</h2>
          <p>
            AVIT held outside the consortium is backed 1:1 by reserves at
            Custodia.
          </p>
          {status === 'error' ? (
            <S.AsOf>
              Reserve metrics are temporarily unavailable. Please check back
              shortly.
            </S.AsOf>
          ) : (
            <>
              <S.MetricsGrid>
                <S.Metric>
                  <S.MetricValue>
                    {data ? usd(data.reservesUsd) : '—'}
                  </S.MetricValue>
                  <S.MetricLabel>Reserves (USD)</S.MetricLabel>
                </S.Metric>
                <S.Metric>
                  <S.MetricValue>
                    {data ? compact(data.stablecoinSupply) : '—'}
                  </S.MetricValue>
                  <S.MetricLabel>AVIT stablecoin supply</S.MetricLabel>
                </S.Metric>
                <S.Metric>
                  <S.MetricValue>
                    {data && data.backingRatio !== null
                      ? pct(data.backingRatio)
                      : '—'}
                  </S.MetricValue>
                  <S.MetricLabel>Backing ratio</S.MetricLabel>
                </S.Metric>
              </S.MetricsGrid>
              <S.AsOf>
                {status === 'loading' || !data
                  ? 'Loading live on-chain values…'
                  : `Live from mainnet as of ${asOfLabel(data.asOf)}`}
              </S.AsOf>
            </>
          )}
        </S.Section>

        <S.Section>
          <h2>Reserve attestations</h2>
          <AttestationList />
        </S.Section>

        <S.Section>
          <h2>Redeem AVIT</h2>
          <p>Placeholder, separate page in progress.</p>
          <S.CtaLink href={'#'}>Go to redemption</S.CtaLink>
        </S.Section>

        */}

        {/* "Join the Hazel Network now" → Vantage CTA — placeholder, URL TBD */}
        <S.Terms>
          <h2>Avit Terms</h2>
          <p>
            The terms of each Avit transferable record can be found in the
            source code for each Avit, which can be found in the source code of
            the implementation contract (via the proxy contract) located here:{' '}
            <a
              href={
                'https://eth.blockscout.com/address/0xdA3d14B7De411609D166ADcb8EA623CC74A21E82?tab=contract'
              }
              target={'_blank'}
              rel={'noopener noreferrer'}
            >
              https://eth.blockscout.com/address/0xdA3d14B7De411609D166ADcb8EA623CC74A21E82?tab=contract
            </a>
            . As further described in such terms, each Avit is a transferable
            record pursuant to Section 16 of the Uniform Electronic Transactions
            Act, pursuant to which Custodia unconditionally promises to pay a
            holder one (1) U.S. dollar to redeem one (1) Avit on demand.
            Custodia is at all times subject to applicable Law, including,
            without limitation, that any Avit may be forfeited or subject to
            forfeiture to, or seizure by, a law enforcement agency, if the Avit
            has been or is being used for illegal activity or is subject to a
            legal order or other process, and that any Avit subject to such
            forfeiture or seizure, or that is otherwise subject to freezing or
            any similar limitation or use, may be wholly and permanently
            unrecoverable and unusable and may, in appropriate circumstances, be
            destroyed. For more information, please refer to the terms of each
            Avit located in its source code.
          </p>
        </S.Terms>
      </S.ScreenWrapper>
    </Shell>
  )
}
